import { Component, inject } from '@angular/core';
import { ProductAddToCartTemplateDialogBaseComponent } from 'projects/shared/lib/components/shared/base/dialog/product-add-to-cart-list-dialog/product-add-to-cart-list-dialog-base.component';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { ShoppingCartDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
    selector: 'app-product-add-to-cart-list-dialog',
    templateUrl: './product-add-to-cart-list-dialog.component.html',
    standalone: false
})
export class ProductAddToCartListDialogComponent extends ProductAddToCartTemplateDialogBaseComponent {
    private readonly localCartDataService: ICartService = inject(ICartServiceToken);
    public newCartCreate(templateName: string | undefined) {
        if (!templateName || templateName.trim().length <= 0) {
            return;
        }
        this.localCartDataService.cartTemplateAdd(templateName.trim()).subscribe(
            (result) => {
                if (result && result.cartNumber != undefined) {
                    this.localCartDataService.cartTemplateListUpdateAsync();
                    let newCart = result as unknown as ShoppingCartDto;
                    newCart.cartName = templateName.trim();
                    newCart.itemCount = 0;
                    if (this.shoppingCartList) {
                        this.shoppingCartList.push(newCart);
                    }
                    this.shoppingCartTemplate = newCart;
                    this.shoppingCartTemplateNewName = undefined;
                }
            },
            (error) => {
                console.error('Fehler beim Erstellen der neuen Einkaufsliste', error);
            }
        );
    }
}
